import {createTheme} from '@material-ui/core/styles';
import sv from '../styles';

const palette = {
    primary: {
        main: sv.colors.cta,
        light: sv.colors.subtleGrey
    },
    secondary: { main: sv.colors.cta },
    action: {
        active: sv.colors.light,
        hover: sv.colors.light,
        hoverOpacity: 0.08
    }
};
const themeName = 'Golden Bell Golden Bell Dogs';
const typography = {
    useNextVariants: true,
    fontFamily: 'Work Sans',
};

const overrides = {
    MuiDropzoneArea: {
        text: {
            color: sv.colors.darkGray,
            fontSize: 14
        },
        icon: {
            color: sv.colors.darkGray
        }
    }
};

export default createTheme({
    palette,
    themeName,
    typography,
    overrides
});
